import React from 'react';
import styles from '../index.module.scss';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from '../../../../../../../Inputs/TextField';
import classNames from 'classnames';
import { getDate } from '../../../../../../../../services/timeService';
import { FormControl } from '@mui/material';
import CustomDatePicker from '../../../../../../../CustomDatePicker';
import { dateTimeFormat } from '../../../../../../../../services/timeService/types';

const BasicBlock = ({ required = true }: { required?: boolean }) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <div className="flex items-center gap-4">
        <TextField
          label="First name"
          data-testid={'firstName'}
          wrapperClassName={styles.inputWrapper}
          inputClassName={styles.inputField}
          {...register('firstName', { required: required && 'Please enter first name' })}
          required={required}
        />
        <TextField
          label="Last name"
          data-testid={'lastName'}
          wrapperClassName={classNames(styles.inputWrapper, styles.lastField)}
          inputClassName={styles.inputField}
          {...register('lastName', { required: required && 'Please enter last name' })}
          required={required}
        />
      </div>
      <FormControl
        error={!!errors?.dateOfBirth}
        required
        data-testid={'dob'}
        className={classNames({
          [styles.error]: errors?.dateOfBirth,
        })}
      >
        <Controller
          render={({ field }) => (
            <CustomDatePicker
              label={'Date of birth'}
              {...register('dateOfBirth', {
                required: required && 'Please enter a valid date',
              })}
              maxDate={getDate()}
              isRequired={required}
              onChange={(date) => {
                field.onChange(date?.format(dateTimeFormat.SERVER_DATE_FORMAT));
              }}
              isError={!!errors?.dateOfBirth}
              helperText={errors?.dateOfBirth?.message as string}
              labelClassName={styles.datePickerStyle}
            />
          )}
          name={'dateOfBirth'}
          control={control}
        />
      </FormControl>
    </>
  );
};

export default BasicBlock;
